import React from "react"
import PropTypes from "prop-types"
import { FormLabel } from "react-bootstrap"
import ExplainedToggle from "components/ExplainedToggle"
import Tooltip from "components/Tooltip"

import Icon from "app/static/frontend/components/Icon"
import "app/static/stylus/FormStyles.styl"
import "../stylus/ExplainedToggleField.styl"

export const ExplainedToggleField = (props) => {
    const {
        input: { value, onChange },
        meta: { error, warning },
        className,
        dataCy,
        label,
        labelStyle,
        additionalClasses,
        off,
        offExplanation,
        on,
        onExplanation,
        size,
        tooltipText,
        disabled,
    } = props

    return (
        <div className={`form-explained-toggle-field ${className}`}>
            <div className="form-explained-toggle-label">
                {label && (
                    <FormLabel className="control-label" style={labelStyle}>
                        {`${label} `}
                        {tooltipText && <Tooltip label={tooltipText} />}
                    </FormLabel>
                )}
                {
                    // Show error message on top level
                    (error || warning) && (
                        <div>
                            <div
                                className={`explained-toggle-meta-text form-explained-toggle-${
                                    error ? "error" : "warning"
                                }`}
                            >
                                <span>{error || warning}</span>
                                <Icon
                                    name={error ? "times" : "exclamation-triangle"}
                                    className="explained-toggle-icon"
                                    lg
                                />
                            </div>
                        </div>
                    )
                }
            </div>
            <ExplainedToggle
                active={Boolean(value)}
                additionalClasses={additionalClasses}
                off={off}
                offExplanation={offExplanation}
                on={on}
                onExplanation={onExplanation}
                onChange={onChange}
                size={size}
                dataCy={dataCy}
                disabled={disabled}
            />
        </div>
    )
}

ExplainedToggleField.propTypes = {
    additionalClasses: PropTypes.array,
    className: PropTypes.string,
    input: PropTypes.object,
    label: PropTypes.string,
    labelStyle: PropTypes.string,
    meta: PropTypes.object,
    off: PropTypes.string.isRequired,
    offExplanation: PropTypes.string.isRequired,
    on: PropTypes.string.isRequired,
    onExplanation: PropTypes.string.isRequired,
    size: PropTypes.string,
    tooltipText: PropTypes.string,
    dataCy: PropTypes.string,
    disabled: PropTypes.bool,
}

export default ExplainedToggleField
